import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useUserVaultsRowsStyle = createUseStyles({
    tr: {
        height: 70,
        borderTop: `1px solid ${color.border.opaque}`,
        '& td': {
            padding: `0 ${spacing['05']}`,
            fontWeight: 600,
        },
    },
    rewards: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            width: 32,
            height: 32,
            marginRight: spacing['04'],
        },
    },
    buttonTd: {
        width: '10%',
    },
    button: {
        width: 100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none',
    },
    balance: {
        '& span': {
            color: color.content.secondary,
        },
    },
});
